// extracted by mini-css-extract-plugin
module.exports =  {"label":"_6c97079b1b--label--hIfaq","cursor_pointer":"_6c97079b1b--cursor_pointer--Pe1mY"};